import { EventEmitter, Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class HeaderService {
    titleObservable = new EventEmitter<string>();

    setTitle(title: string){
        this.titleObservable.emit(title);
    }
}